const addLeadingZero = (num) => {
  return (num < 10 ? '0' : '') + num;
};

const TimeFormatHourMinSec = (seconds) => {
  if (isNaN(seconds)) {
    seconds = 0;
  }

  const hh = addLeadingZero(Math.floor(seconds / 3600));
  const mm = addLeadingZero(Math.floor(seconds / 60) % 60);
  const ss = addLeadingZero(Math.floor(seconds) % 60);

  return `${hh}:${mm}:${ss}`;
};

const TimeFormatHourMin = (seconds) => {
  if (isNaN(seconds) || seconds < 0) {
    seconds = 0;
  }

  const hh = addLeadingZero(Math.floor(seconds / 3600)).replace(/^0/i, '')
  const mm = addLeadingZero(Math.floor(seconds / 60) % 60).replace(/^0/i, '')
  const ss = addLeadingZero(Math.floor(seconds) % 60).replace(/^0/i, '')

  if (hh !== '0') {
    return `${hh} godz. ${mm} min`;
  }

  return `${mm} min`;
};

export { TimeFormatHourMinSec, TimeFormatHourMin };
// export default timeFormat;
